import {Component, isDevMode, OnInit} from '@angular/core';
import {AngularFireDatabase} from 'angularfire2/database';
import {AngularFireAuth} from 'angularfire2/auth';
import {Observable} from 'rxjs/Observable';
import * as firebase from 'firebase/app';
import {NgForm} from '@angular/forms';
import {Router} from '@angular/router';
import {MatSnackBar} from '@angular/material';
import {TranslateService} from '@ngx-translate/core';
import {TimeTrackerService} from '../time-tracker-service.service';
import {User} from '../../models/User';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {

    user: Observable<firebase.User>;
    username: string = '';
    password: string = '';

    constructor(public afAuth: AngularFireAuth, public af: AngularFireDatabase, public router: Router, public snackBar: MatSnackBar,
                public trans: TranslateService) {
        this.user = this.afAuth.authState;

        this.afAuth.authState.subscribe(auth => {
            if (auth) {
                router.navigate(['/']);
            }
        });

        if (isDevMode()) {
            this.username = 'eyvind.coaquira@gmail.com';
            this.password = '987654321';
        }
    }

    ngOnInit() {

    }

    doLogin(username: string, password: string) {
        this.afAuth.auth.signInWithEmailAndPassword(username, password)
            .then((firebaseUser) => {
                const subs = this.af.object<User>(TimeTrackerService.USERS + '/' + firebaseUser.uid)
                    .valueChanges()
                    .subscribe(user => {
                        console.log('user: ', user);
                        subs.unsubscribe()
                        if (user.isAdmin) {
                            this.router.navigate(['/']);
                        } else {
                            this.afAuth.auth.signOut();
                            this.trans.get('LOGIN.CANT_PRIVILEGES').subscribe((res: string) => {
                                this.snackBar.open(res, null, {duration: 1500});
                            });
                        }
                    });
            }).catch((error) => {
                this.trans.get('LOGIN.USERNAME_IS_INCORRECT').subscribe((res: string) => {
                    this.snackBar.open(res, null, {duration: 1500});
                });
            }
        );
    }

    register() {
        this.router.navigate(['/register']);
    }

    public submitFormLogin(form: NgForm) {
        console.log('submitForm', form);
        // TODO:Handle validation here
        this.doLogin(this.username, this.password);
    }
}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts